import { gql } from '@apollo/client';
import { CORE_EVENT_FIELDS } from '@general/graphql/fragments/event';

export const EVENTS_QUERY = gql`
    ${CORE_EVENT_FIELDS}
    query getEvents($codes: [String!]) {
        events(codes: $codes) {
            ...CoreEventFields
        }
    }
`;

export const SAVED_EVENTS_QUERY = gql`
    query getSavedEvents {
        viewerEvents(type: SAVED) {
            recordId
            code
            title
            url
            beginsAt
            endsAt
            location {
                purpose
                address
                city
                stateProvince
                country
            }
        }
    }
`;

export const REGISTERED_EVENTS_QUERY = gql`
    query getRegisteredEvents {
        viewerEvents(type: REGISTERED) {
            id
            recordId
            code
            title
            url
            beginsAt
            endsAt
            image
            location {
                purpose
                address
                city
                stateProvince
                country
            }
        }
    }
`;

export const GET_EVENT_SLOTS = gql`
    query GetEventSlots($eventCode: String) {
        eventSlots(eventCode: $eventCode) {
            id
            eventCode
            startsAt
            endsAt
        }
    }
`;

export const SAVE_EVENT = gql`
    mutation SaveEvent($recordId: Int!) {
        saveEvent(recordId: $recordId) {
            event {
                recordId
            }
        }
    }
`;

export const REMOVE_EVENT = gql`
    mutation RemoveEvent($recordId: Int!) {
        removeEvent(recordId: $recordId) {
            event {
                recordId
            }
        }
    }
`;
